import { ReactNode, createContext, useContext } from "react";

export const ModalContext = createContext({
  open(node: ReactNode) {},
  close() {},
});

export const useModal = () => useContext(ModalContext);
